import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    background-color: ${props => props.theme.colours.textWhite};
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    max-width: 340px;
    width: 100%;
    margin: 0 auto;
`;

export const CardHeader = styled.div`
    position: relative;
    background-image: url('${props => props.bgImage}');
    background-size: cover;
    background-position: center top;
    height: 120px;
`;

export const Itv7Logo = styled.img`
    position: relative;
    z-index: 1;
    width: 120px;
    height: auto;
`;

export const CardBody = styled.div`
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const Title = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large2};
    color: ${props => props.theme.colours.textDark};
    text-transform: uppercase;
    margin-bottom: 8px;
`;

export const Body = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.small};
    color: ${props => props.theme.colours.textDark};
    line-height: 18px;
    margin-bottom: 14px;
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    margin-bottom: 10px;

    & button {
        border-radius: 20px;
    }
`;

export const Terms = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-weight: 400;
    font-size: ${props => props.theme.fontSize.xsmall};
    color: ${props => props.theme.colours.textDark};
    line-height: 16px;
`;

export const TermsLink = styled(Terms)`
    text-decoration: underline;
    color: ${props => props.theme.colours.textDark};
    cursor: pointer;
`;
